module.exports = __webpack_public_path__ + "static/media/smallBlueTemplate.5fdc1550.png";